import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		display: "flex",
		flexDirection: "column",
		padding: theme.spacing(2),
		minHeight: `calc(100% - 48px)`,
		height: "auto",
		minWidth: 0,
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(1.5),
		},
	},

	contentWrapper: {
		flex: 1,
		minHeight: 0,
		width: "100%",
		overflow: "visible",
		display: "flex",
		flexDirection: "column",
	},
}));

const MainContainer = ({ children, className, contentClassName, fullWidth = false }) => {
	const classes = useStyles();

	return (
		<Container
			className={clsx(classes.mainContainer, className)}
			maxWidth={fullWidth ? false : undefined}
			disableGutters={fullWidth}
		>
			<div className={clsx(classes.contentWrapper, contentClassName)}>{children}</div>
		</Container>
	);
};

export default MainContainer;
